/**
 * Formats an ISO date-time string in the European style: dots in the date and
 * colons in a 24-hour time, e.g. "10.07.2026 01:04:49". Returns "" for empty or
 * unparseable input.
 */
export function formatDateTimeEu(value: string | null | undefined): string {
    if (!value) {
        return "";
    }

    const date = new Date(value);
    if (isNaN(date.getTime())) {
        return "";
    }

    const pad = (part: number): string => String(part).padStart(2, "0");

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
}
